import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ModalService } from './modal.service';

@Component({
  selector: 'atlas-modal-footer',
  templateUrl: './modal-footer.component.html',
  styleUrls: ['./modal-footer.component.scss']
})
export class ModalFooterComponent {
  public isMobile$: Observable<boolean>;

  constructor(private modalService: ModalService) {
    this.isMobile$ = this.modalService.mobile$;
  }
}
